var map = {
	"./certificate_automatic_frame.png": 132,
	"./certificate_ects_frame.png": 133,
	"./certificate_frame.png": 134,
	"./certificate_verified_frame.png": 135,
	"./frame_blue_de.png": 136,
	"./frame_blue_en.png": 137,
	"./frame_gold_de.png": 138,
	"./frame_gold_en.png": 139,
	"./frame_green_de.png": 140,
	"./frame_green_en.png": 141,
	"./generic_audit_sample.jpg": 142,
	"./generic_bundle_sample.jpg": 143,
	"./generic_coa_ects_sample.jpg": 144,
	"./generic_coa_sample.jpg": 145,
	"./generic_sop_sample.jpg": 146,
	"./milestone_completed.png": 147,
	"./milestone_uncompleted.png": 148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;